import { makeStyles } from '@material-ui/core';

export default makeStyles({
  container: {
    backgroundColor: 'white',
    position: 'relative',
    display: 'flex',
    width: '100%',
    borderRadius: 14,
    flexDirection: 'row',
    flex: 1,
    minHeight: 168,
    maxHeight: 168,
    height: 168,
    border: '1px solid #E8ECF2',
    boxShadow: '0 2px 10px rgba(17, 24, 39, 0.06)',
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: '#003366',
      boxShadow: '0 2px 10px rgba(17, 24, 39, 0.06)',
    },
  },
  imgContainer: {
    display: 'flex',
    width: 84,
    height: '100%',
    alignItems: 'flex-start',
  },
  userImage: {
    width: '56px',
    height: '56px',
    margin: '18px 0px 0px 16px',
  },
  textHeader: {
    marginLeft: 3,
    marginTop: 10,
    marginBottom: 8,
    minHeight: 40,
    maxWidth: 200,
  },
  userName: {
    color: '#505255',
    fontSize: 16,
    fontFamily: 'Poppins',
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  scaleName: {
    color: '#8b8e93',
    fontSize: 13,
    fontFamily: 'Poppins',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  infoContainer: {
    flexWrap: 'wrap',
    flex: 1,
    width: '100%',
    justifyContent: 'space-evenly',
    paddingRight: 6,
  },
  dateRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'nowrap',
    maxWidth: 240,
    width: '100%',
    color: '#8b8e93',
    fontSize: 12,
  },
  iconDateContainer: {
    marginRight: 10,
    color: '#8B8E93',
    fontSize: 12,
    fontFamily: 'Poppins',
    width: 110,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  green: {
    color: '#008A00',
  },
  orange: {
    color: 'orange',
  },
  red: {
    color: 'red',
  },
  circleContainer: {
    marginLeft: 14,
    minWidth: 82,
    minHeight: 82,
    maxWidth: 82,
    maxHeight: 82,
    color: '#003366',
    borderColor: '#003366',
    marginTop: 22,
    marginRight: 14,
  },
  textWorkHour: {
    fontFamily: 'Poppins',
    fontSize: '12px',
    color: '#003366',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 210,
  },
  progressText: {
    textAlign: 'center',
    color: '#003366',
    fontSize: 14,
  },
  textStatus: {
    textAlign: 'center',
    color: '#003366',
    fontSize: 12,
    maxWidth: 50,
  },
  blueColor: {
    color: '#003366',
    fontSize: 17,
    marginRight: 5,
    marginLeft: 2,
  },
  statusRow: {
    display: 'flex',
    marginTop: 8,
    alignItems: 'center',
    minHeight: 20,
    maxWidth: 220,
  },
  upIcon: {
    position: 'relative',
    bottom: 2,
    fontSize: 10,
  },
});
